import React from 'react';
import Immutable from 'immutable';
import styled from 'styled-components';
import {defaultTheme} from '../../data/themes';
import Centerer from '../containers/centerer';

const Container = styled.div`
	position: absolute;
	left: 0px;
	top: 0px;
	height: 100%;
	width: 100%;
	background: ${props => props.theme.modalOverlayBackground || defaultTheme.modalOverlayBackground};

`;

export default class ModalContainer extends React.Component {
	render() {
		return (
			<Container className="ps-modalContainer">
				{
					this.props.noCenterer ? this.props.children : (
						<Centerer>
							{this.props.children}
						</Centerer>
					)
				}
			</Container>
		)
	}
}

